AccordionBlock = new class {
    constructor() {}
    click(button, jsclass) {
        if (button && button.parentNode) {
            let element = button.parentNode;
            let status = button.getAttribute('aria-expanded') == 'false';
            let label = status == false ? 'Ver enlaces de inter&eacute;s' : 'Cerrar enlaces de inter&eacute;s';
            let span = button && button.querySelector('span');
            element && element.classList.toggle('ue-c-popular-links--closed');
            button && button.setAttribute('aria-expanded', status);
            span.innerHTML = label;
            let uls = element.querySelectorAll('ul') || [];
            uls.forEach((ul) => {
                ul && ul.setAttribute('aria-hidden', !status);
                ul.classList.toggle('hidden-content');
            });
        }
    }
}
